
import React from 'react';
import { InputContainer } from '../../../../common/components/form/form.module';

export const CompaignRecipientInfoComponent = ({
  choosenEmailPlan,
  choosenCampaign,
  customerTags,
  handleInnerFormChange,
}: any) => {
 
  return (
    <>
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
      isDisabled
                label="Reply To"
                labelField="Reply To"
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(event.target.value, 'ReplyToEmailInclusions');
                }}
                type="text"
                value={choosenEmailPlan?.ReplyToEmailInclusions}
              />

<InputContainer
isDisabled
          label="Recipient" 
          labelField="displayText"
          list={customerTags}
          onValueChange={( newValue: any) => {
            const categoryData: any = newValue.map((option: any) => option?.value || '')
            handleInnerFormChange(
              categoryData,
              'RecipientTagIdInclusions',
            );
          }}
          type="multiselect"
          valueField="ValueId"
          value={choosenEmailPlan?.RecipientTagIdInclusions}
        />
        {/* <InputContainer
          label="Recipient" 
          labelField="displayText"
          list={customerTags}
          onValueChange={( newValue: any) => {
            const categoryData: any = newValue.map((option: any) => option?.value || '')
            handleInnerFormChange(
              categoryData,
              'RecipientTagIdInclusions',
            );
          }}
          type="multiselect"
          valueField="ValueId"
          value={choosenEmailPlan?.RecipientTagIdInclusions}
        />  */}
        <InputContainer
        isDisabled
          label="CC" 
          labelField="displayText"
          list={customerTags}
          onValueChange={( newValue: any) => {
            const categoryData: any = newValue.map((option: any) => option?.value || '')
            handleInnerFormChange(
              categoryData,
              'CCTagIdInclusions',
            );
          }}
          type="multiselect"
          valueField="ValueId"
          value={choosenEmailPlan?.CCTagIdInclusions} 
        /> 
        <InputContainer
        isDisabled
          label="BCC" 
          labelField="displayText"
          list={customerTags}
          onValueChange={( newValue: any) => {
            const categoryData: any = newValue.map((option: any) => option?.value || '')
            handleInnerFormChange(
              categoryData,
              'BCCTagIdInclusions',
            );
          }}
          type="multiselect"
          valueField="ValueId"
          value={choosenEmailPlan?.BCCTagIdInclusions}
        /> 
      </div>
       
    </>
  );
};
export default CompaignRecipientInfoComponent;
